import React, { PureComponent } from 'react'
import { Button, FormCheck, Collapse, Alert } from 'react-bootstrap'
import { formatTimeString } from '../../../utils/formatters'
import './styles.css'

class DataHitListItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      allChecked: false,
    }
  }

  componentDidMount() {}

  collapseSection = () =>
    this.setState({
      open: !this.state.open,
    })

  confirm = (event) => {
    this.setState({
      allChecked: event.target.checked,
    })
    this.props.confirm(event)
  }

  sendLink = () => window.open(this.props.shareURL, '_blank')

  render() {
    const { props, state } = this
    const { hit, shareURL, type } = props
    const amlHitMatchTypesPropertyName = `${type}_aml_hit_match_types`
    const types = hit[amlHitMatchTypesPropertyName].map((i) => i.name).join(' ')
    const matched = hit.amlSourceNotes.map((i) => i.identifier).join(' ')
    const countries = [
      ...new Set(hit.amlSourceNotes.map((i) => i.aml_source_countries.map((c) => c.country)).flat()),
    ].join(' ')

    const amlHitAssetsPropertyName = `${type}_aml_hit_assets`
    const images = hit[amlHitAssetsPropertyName].filter((i) => i.asset_type === 'picture')
    const pdfs = hit[amlHitAssetsPropertyName].filter((i) => i.asset_type === 'pdf')
    const image = images.length > 0 ? images[0].public_url : ''
    const pdf = pdfs.length > 0 ? pdfs[0].public_url : ''
    const chevronClass = state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    return (
      <tr className={'data-listing-item'}>
        <td>
          <div className={'data-listing-item-header'}>
            <div onClick={this.collapseSection} className={'data-listing-item-header-label'}>
              {hit.name}
              <i style={{ paddingLeft: 10, width: '10px' }} className={chevronClass} />
            </div>
          </div>
          <Collapse in={state.open}>
            <div style={{ paddingTop: 5 }}>
              <Alert variant={'secondary'} className='section-shadow data-listing-item-section' size={'lg'}>
                <div style={{ paddingTop: 5, maxWidth: 215 }}>
                  <div className={'data-listing-item-section-item'}>
                    <i className='fa fa-exclamation-triangle' style={{ color: '#f8ac59' }} />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>Matched: {matched}</div>
                  </div>
                  <div className={'data-listing-item-section-item'}>
                    <i className='fa fa-info-circle' style={{ color: '#1ab394' }} />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>Relevance: {types}</div>
                  </div>
                  <div className={'data-listing-item-section-item'}>
                    <i style={{ color: 'grey' }} className='fa fa-list-alt' />
                    <div>Match found on {hit.amlSourceNotes.length} list</div>
                  </div>
                  <div className={'data-listing-item-section-item'}>
                    <i style={{ color: '#557491' }} className='fa fa-user' />
                    <div>Type: Person</div>
                  </div>
                  <div className={'data-listing-item-section-item'}>
                    <i style={{ color: '#557491' }} className='fa fa-list' />
                    <div>Case: {hit.provider_id}</div>
                  </div>
                  <div style={{ marginTop: 5 }}>
                    <Button
                      disabled={!shareURL}
                      className='section-shadow'
                      bsPrefix='btn btn-w-m btn-default'
                      onClick={this.sendLink}
                    >
                      External Link to More Data
                    </Button>
                  </div>
                </div>
                <div className='section-shadow data-listing-item-data'>
                  {image && (
                    <div>
                      Images:
                      <div style={{ maxWidth: '100px', height: 'auto', margin: '10px' }}>
                        <a href={image} target={'_blank'} rel='noreferrer'>
                          <img src={image} alt='' style={{ width: '100%' }} />
                        </a>
                      </div>
                    </div>
                  )}
                  {pdf && (
                    <div>
                      PDF:
                      <div style={{ margin: '10px' }}>
                        <a href={pdf} target={'_blank'} rel='noreferrer'>
                          {pdf}
                        </a>
                      </div>
                    </div>
                  )}
                  Listing Data:
                  <ul>
                    {hit.amlSourceNotes.map((h, i) => (
                      <li key={i}>
                        {h.name}{' '}
                        {h.listing_started ? <div>(Added to list On: {formatTimeString(h.listing_started)})</div> : ''}
                        {h.listing_ended ? <div>(Removed from list On: {formatTimeString(h.listing_ended)})</div> : ''}
                        {h.related_url && (
                          <span>
                            {' '}
                            <br />
                            <a target={'_blank'} href={h.related_url} rel='noreferrer'>
                              {h.related_url}
                            </a>
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                  {countries && <div>Countries: {countries}</div>}
                  <div>
                    {hit.related_url && (
                      <div>
                        External Link:{' '}
                        <a target={'blank'} href={hit.related_url}>
                          {hit.related_url}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </Alert>
            </div>
          </Collapse>
        </td>
        <td style={{ width: '10%' }}>
          <FormCheck
            defaultChecked={props.checked}
            value={this.state.allChecked}
            onClick={this.confirm}
            onChange={this.handleChange}
          />
        </td>
      </tr>
    )
  }
}

export default DataHitListItem
